const EXECUTABLE_EXTENSIONS_LIST = <const>[
  '8ck',
  '73k',
  '89k',
  'a6p',
  'a7r',
  'ac',
  'acc',
  'acr',
  'actc',
  'action',
  'actm',
  'afmacro',
  'afmacros',
  'ahk',
  'air',
  'apk',
  'app',
  'appimage',
  'applescript',
  'arscript',
  'asb',
  'atmx',
  'azw2',
  'ba_',
  'bat',
  'beam',
  'bin',
  'bin',
  'bms',
  'btm',
  'caction',
  'cel',
  'celx',
  'cgi',
  'cheat',
  'cmd',
  'cof',
  'coffee',
  'com',
  'command',
  'csh',
  'cyw',
  'dek',
  'dld',
  'dmc',
  'ds',
  'dxl',
  'e_e',
  'ear',
  'ebacmd',
  'ebm',
  'ebs',
  'ebs2',
  'ecf',
  'eham',
  'elf',
  'epk',
  'es',
  'esh',
  'ex4',
  'ex5',
  'ex_',
  'ex_',
  'exe',
  'exe',
  'exe1',
  'exopc',
  'ezs',
  'ezt',
  'fas',
  'fas',
  'fky',
  'fpi',
  'frs',
  'fxp',
  'gadget',
  'gm9',
  'gpe',
  'gpu',
  'gs',
  'ham',
  'hms',
  'hpf',
  'hta',
  'icd',
  'iim',
  'ipa',
  'ipf',
  'ipk',
  'isu',
  'ita',
  'jar',
  'js',
  'jse',
  'jsf',
  'jsx',
  'kix',
  'ksh',
  'kx',
  'lo',
  'ls',
  'm3g',
  'mac',
  'mam',
  'mamc',
  'mcr',
  'mcr',
  'mcr',
  'mel',
  'mem',
  'mhm',
  'mio',
  'mlx',
  'mm',
  'mrc',
  'mrp',
  'ms',
  'ms',
  'msl',
  'mxe',
  'n',
  'ncl',
  'nexe',
  'ore',
  'osx',
  'otm',
  'out',
  'paf',
  'pex',
  'phar',
  'pif',
  'plsc',
  'plx',
  'prc',
  'prg',
  'prg',
  'prg',
  'ps1',
  'pvd',
  'pwc',
  'pyc',
  'pyo',
  'qit',
  'qpx',
  'rbf',
  'rbx',
  'rfs',
  'rfu',
  'rgs',
  'rox',
  'rpj',
  'run',
  'rxe',
  's2a',
  'sapk',
  'sbs',
  'sca',
  'scar',
  'scb',
  'scpt',
  'scptd',
  'scr',
  'script',
  'sct',
  'seed',
  'server',
  'sh',
  'shb',
  'shortcut',
  'sk',
  'smm',
  'snap',
  'spr',
  'sts',
  'tcp',
  'thm',
  'tiapp',
  'tms',
  'tpk',
  'u3p',
  'udf',
  'upx',
  'uvm',
  'vbe',
  'vbs',
  'vbscript',
  'vdo',
  'vexe',
  'vlx',
  'vpm',
  'vxp',
  'wcm',
  'widget',
  'widget',
  'wiz',
  'workflow',
  'wpk',
  'wpm',
  'ws',
  'wsf',
  'wsh',
  'x86',
  'x86_64',
  'xap',
  'xbap',
  'xbe',
  '0xe',
  'xex',
  'xlm',
  'xqt',
  'xys',
  'ygh',
  'zl9',
];
const EXECUTABLE_EXTENSIONS_MAP = <Record<string, true>>(
  Object.fromEntries(EXECUTABLE_EXTENSIONS_LIST.map(ext => [ext, true]))
);

export const isExecutableFile = (fileName: string): boolean => {
  if (!fileName) return false;

  const parts = fileName.split('.');
  const extension = parts[parts.length - 1];
  return !!EXECUTABLE_EXTENSIONS_MAP[extension];
};
